import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import LayoutContext, { ILayoutContext } from "../../../contexts/layout/LayoutContext";
import PhoneLink from "../../../laco-common/components/PhoneLink";
import { IPSFacility } from "../../../models/peer-support";
import { UIStyledTooltip } from "../../ui/UIComponents";
import { FacilityActions, FacilityActionsProps } from "./FacilityActions";
import { PhoneLinkWeb } from "../../ui/PhoneLinkWeb";
import { UIAddress, AddressImage } from "../../google-maps/Address";
import { FacilityResources } from "./FacilityResources";
import { PSAdminContent, IS_EMBED } from "..";
import { UIPageTitle } from "../../ui/UIPageTitle";

export type FacilityDetailProps = FacilityActionsProps;

export const FacilityDetail: React.FC<FacilityDetailProps> = (props: FacilityDetailProps) => {
	// const context: ILayoutContext = useContext(LayoutContext);
	const facility: IPSFacility = props.facility;

	const facilityHeader = (
		<div className={clsx("container-fluid bg-gray1", IS_EMBED && "mt-2")}>
			<div className={clsx(!IS_EMBED && "container", IS_EMBED && "p-2", "py-4_5")}>
				<div className="row">
					<div className="col-12 col-sm-5 col-md-4">
						<h2>{facility.name}</h2>
						<UIStyledTooltip title="Back to facilities">
							<NavLink to="ps/facilities">
								<IconButton className="ui-icon-btn-floating mt-1" aria-label="Delete" size="small">
									<ArrowBackIcon />
								</IconButton>
							</NavLink>
						</UIStyledTooltip>
					</div>
					<div className="text-sm col-12 col-sm-4 col-md-5 mt-1 mb-3-mobile mt-4-mobile d-flex flex-column">
						<PhoneLinkWeb className="mb-2" number={facility.phone} />
						<UIAddress address={facility.address} showZipOnly={facility.showZipCodeOnly} />
					</div>
					<PSAdminContent>
						<div className="col-12 col-sm-3 col-md-3">
							<h4 className="d-none d-md-inline-block mb-3">Actions</h4>
							<FacilityActions {...props} omitLink={true} />
						</div>
					</PSAdminContent>
				</div>
			</div>
		</div>
	);

	const hasResources: boolean = !!facility.resources && !!facility.resources.length;

	return (
		<>
			<UIPageTitle pageTitle={facility.name} />
			{facilityHeader}
			<div className={clsx(!IS_EMBED && "container", IS_EMBED && "p-2", "my-4_5")}>
				<div className="row">
					<div className={clsx("pb-4 col-12", hasResources && "col-md-5")}>
						<h2 className="mb-3">Location</h2>
						<AddressImage address={facility.address} />
					</div>
					{hasResources && (
						<>
							<div className="col-12 col-md-1 mb-2"></div>
							<div className="pb-3 col-12 col-md-6">
								<h2 className="mb-3">Facility Resources</h2>
								<FacilityResources facility={facility} />
							</div>
						</>
					)}
				</div>
			</div>
		</>
	);
};
